import React, { useRef } from 'react';
import { Alert, Box, Button, Stack, TextField, Typography } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import FormatAlignLeftIcon from '@mui/icons-material/FormatAlignLeft';

const RawConfigJsonEditor = ({ value, onChange, parseError, onFormat, disabled, hideTitle = false }) => {
  const fileInputRef = useRef(null);

  const handleFile = (event) => {
    const file = event.target.files?.[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const text = typeof reader.result === 'string' ? reader.result : '';
      onChange(text);
    };
    reader.readAsText(file);
    event.target.value = '';
  };

  return (
    <Box>
      {!hideTitle && (
        <Typography variant="h6" sx={{ mb: 1 }}>
          Mapping config
        </Typography>
      )}
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Paste or upload the full connector config JSON with nested <code>fields</code>. <code>target</code> and{' '}
        <code>mappingId</code> are filled from the connector if omitted.
      </Typography>

      <Stack direction="row" spacing={1} sx={{ mb: 2 }} flexWrap="wrap" useFlexGap>
        <input ref={fileInputRef} type="file" accept=".json,application/json" hidden onChange={handleFile} />
        <Button
          variant="outlined"
          startIcon={<UploadFileIcon />}
          onClick={() => fileInputRef.current?.click()}
          disabled={disabled}
        >
          Upload config JSON
        </Button>
        <Button
          variant="outlined"
          startIcon={<FormatAlignLeftIcon />}
          onClick={onFormat}
          disabled={disabled || Boolean(parseError)}
        >
          Format JSON
        </Button>
      </Stack>

      <TextField
        fullWidth
        multiline
        minRows={16}
        maxRows={32}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={'{\n  "fields": {\n    "issue_date": { "source": "$.Date" }\n  }\n}'}
        sx={{
          '& .MuiInputBase-root': {
            fontFamily: 'monospace',
            fontSize: '0.8rem',
          },
        }}
      />

      {parseError && (
        <Alert severity="error" sx={{ mt: 2 }}>
          {parseError}
        </Alert>
      )}
    </Box>
  );
};

export default RawConfigJsonEditor;
